import * as React from 'react';

const SvgArrowRight = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 16 16'
    xmlSpace='preserve'
    {...props}
  >
    <path
      className='ArrowRight_svg__st0'
      d='M9.266 3.6a.5.5 0 0 1 .707 0l4.047 4.047a.496.496 0 0 1 0 .707L9.974 12.4a.5.5 0 0 1-.707-.707L12.96 8 9.266 4.307a.5.5 0 0 1 0-.707z'
      fill='currentColor'
    />
    <path
      className='ArrowRight_svg__st0'
      d='M1.833 8a.5.5 0 0 1 .5-.5h11.22a.5.5 0 0 1 0 1H2.333a.5.5 0 0 1-.5-.5z'
      fill='currentColor'
    />
  </svg>
);

export default SvgArrowRight;
